import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PageNotFoundService {
  private readonly isPageNotFound = new BehaviorSubject<boolean>(false);
  checkPageNotFound = this.isPageNotFound.asObservable();

  setPageNotFound() {
    this.isPageNotFound.next(true);
  }
  resetPageNotFound() {
    this.isPageNotFound.next(false);
  }
}
